var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('section',{staticClass:"demo"},[_c('div',{staticClass:"section-content"},[_c('iframe',{staticStyle:{"border":"0","height":"800px","width":"100%"},attrs:{"scrolling":"auto","src":"./file-viewer/index.html?shoHead=true&&fileUrl=/fileTest/pdf.pdf"}})])])])
}]

export { render, staticRenderFns }